import { render, staticRenderFns } from "./CreateOrderInNominative.vue?vue&type=template&id=ad396118"
import script from "./CreateOrderInNominative.vue?vue&type=script&lang=js"
export * from "./CreateOrderInNominative.vue?vue&type=script&lang=js"
import style0 from "./CreateOrderInNominative.vue?vue&type=style&index=0&id=ad396118&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports